import React from "react";
import { Card, Row, Col } from "antd";
import "./ClassroomCard.less";

const ClassroomCard = ({
  coachingName,
  subject,
  batch,
  validTill,
  coachingLogo,
  onClick,
}) => {
  return (
    <Card className='coaching-card' onClick={onClick}>
      <Row gutter={[16, 16]}>
        <Col span={6} className='logo-col'>
          <img src={coachingLogo} alt='logo' className='coaching-logo' />
        </Col>
        <Col span={18}>
          <Row className='info-row'>
            <Col span={12}>
              <div className='info-label'>Coaching name</div>
              <div className='info-value'>{coachingName}</div>
            </Col>
            <Col span={12}>
              <div className='info-label'>Subject</div>
              <div className='info-value'>{subject}</div>
            </Col>
          </Row>
          <Row className='info-row'>
            <Col span={12}>
              <div className='info-label'>Batch</div>
              <div className='info-value'>{batch}</div>
            </Col>
            <Col span={12}>
              <div className='info-label'>Valid till</div>
              <div className='info-value'>{validTill}</div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default ClassroomCard;
